export const AUTOPLAY_SPEED = 6000
export const SLIDE_SPEED = 500
export const DISABLING_DURATION = 5000

export const GROUP_LIST = {
    ALL_MEMBERS: 'ALL_MEMBERS',
    COMMAND_STAFF: 'COMMAND_STAFF',
}

export const TOOLTIP_IDS = {
    LOCKED_ANNOUNCEMENT: 'locked_announcement',
    OUT_OF_CLAN: 'out_of_clan',
    CREATE_NEW_ANNOUNCEMENT_BUTTON: 'create_new_announcement_button_tooltip',
    CREATE_NEW_ANNOUNCEMENT_ICON: 'create_new_announcement_icon_tooltip',
    CREATE_NEW_ANNOUNCEMENT_DISABLED_ICON: 'create_new_announcement_icon_disabled_tooltip',
    EXTERNAL_URL_ICON: 'external_url_icon_tooltip',
    AUTHOR_ROLE: 'author_role_',

    BUTTON_EDIT: 'edit_tooltip',
    BUTTON_ARCHIVE: 'archive_tooltip',
    BUTTON_DELETE: 'delete_tooltip',
    BUTTON_CREATE: 'create_tooltip',
    BUTTON_SAVE: 'save_tooltip',

    EDITOR_HINT_BOLD: 'editor_hint_bold',
    EDITOR_GROUP_TYPE: 'editor_group_type',
    EDITOR_INFO: 'editor_info',
    EDITOR_GROUP_TYPE_ITEMS: {
        [GROUP_LIST.ALL_MEMBERS]: 'group_type_tooltip_all_members',
        [GROUP_LIST.COMMAND_STAFF]: 'group_type_tooltip_command_staff',
    },
}

export const ANNOUNCEMENT_MODE = {
    CARD: 'card',
    VIEW: 'view',
    EDIT: 'edit',
    CREATE: 'create',
    ARCHIVE: 'archive',
    DELETE: 'delete',
}

export const ANNOUNCEMENT_ERROR = {
    EDIT: 'editing_error',
    ARCHIVE: 'archiving_error',
    DELETE: 'deleting_error',
    CREATE: 'creating_error',
    FORBIDDEN_WORDS: 'forbidden_words_error',
}

export const STORAGE_KEYS = {
    READ_ANNOUNCEMENTS: 'billboard_viewed_items',
    READ_NEWS: 'webbrg_viewed_items',
}

export const CARD_TYPES = {
    ANNOUNCEMENTS: 'announcements',
    NEWS: 'news',
    CREATE_NEW_ANNOUNCEMENT: 'create_new_announcement',
}

export const NAVIGATION_DIRECTION = {
    LEFT: 'left',
    RIGHT: 'right',
}

export const FOOTER_EDIT_CONTROLS_STATE = {
    WITHOUT_RESTRICTION: 'without_restriction',
    DISABLED: 'disabled',
    MAX_CHARS: 'max_chars',
    FORBIDDEN_WORDS: 'forbidden_words',
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/AnnouncementsCard/constants.js